/** @format */
export enum AccessoriesChecklistFlagVariant {
    INLINE_QUOTE_EDITING = '2.1-inline-quote-editing',
    ACCESSORIES_CHECKLIST = '2.2-accessories-checklist',
}

export const ACCESSORIES_CHECKLIST_VARIANT_ORDER = [
    AccessoriesChecklistFlagVariant.INLINE_QUOTE_EDITING,
    AccessoriesChecklistFlagVariant.ACCESSORIES_CHECKLIST,
] as const;

export const ACCESSORIES_CHECKLIST_FEATURE_FLAG_DEFAULT =
    'LOVE-1153-(sell-journey-accessories-checklist)' as const;
